export function projects(
  state = {
    projects: [],
    projectUsages: [],
    usersAccepted: [],
    usersInvited: [],
    userInvitations: [],
    isLoading: false,
    options: [],
    criteriaErr: null,
    successMessage: null,
  },
  action
) {
  switch (action.type) {
    case 'GET_PROJECTS_START':
      return {
        ...state,
        projects: [],
        isLoading: true,
      };

    case 'GET_PROJECTS_DONE':
      return {
        ...state,
        projects: action.projects,
        isLoading: false,
      };

    case 'GET_PROJECT_USAGES_START':
      return {
        ...state,
        projectUsages: [],
      };

    case 'GET_PROJECT_USAGES_DONE':
      return {
        ...state,
        projectUsages: action.projectUsages,
      };

    case 'EDIT_PROJECT_START':
      return state;

    case 'EDIT_PROJECT_DONE':
      return {
        ...state,
        projects: state.projects.map(element => {
          if (element.id === action.project.id) {
            return action.project;
          }
          return element;
        }),
      };

    case 'SAVE_PROJECT_START':
      return state;

    case 'SAVE_PROJECT_DONE':
      return {
        ...state,
        projects: [...state.projects, action.project],
      };

    case 'DELETE_PROJECT_START':
      return state;

    case 'DELETE_PROJECT_DONE':
      return {
        ...state,
        projects: state.projects.filter(element => {
          if (element.id !== action.deletedProject) {
            return element;
          }
        }),
      };

    case 'GET_USERS_ACCEPTED_START':
      return {
        ...state,
        usersAccepted: [],
      };

    case 'GET_USERS_ACCEPTED_DONE':
      return {
        ...state,
        usersAccepted: action.usersAccepted,
      };

    case 'GET_USERS_INVITED_START':
      return {
        ...state,
        usersInvited: [],
      };

    case 'PROJECTS_SUCCESS':
      return {
        ...state,
        successMessage: action.successMessage,
      };

    case 'GET_USERS_INVITED_DONE':
      return {
        ...state,
        usersInvited: action.usersInvited,
      };
    case 'GET_USER_INVITATIONS_START':
      return {
        ...state,
        userInvitations: [],
      };

    case 'GET_USER_INVITATIONS_DONE':
      return {
        ...state,
        userInvitations: action.userInvitations,
      };
    case 'REMOVE_USER_FROM_PROJECT_START':
      return state;

    case 'REMOVE_USER_FROM_PROJECT_DONE':
      return {
        ...state,
        usersInvited: state.usersInvited.filter(element => {
          if (element.userId !== action.userDeleted) {
            return element;
          }
        }),
      };
    case 'ACCEPT_INVITATION_START':
      return state;

    case 'REMOVE_INVITATION':
      return {
        ...state,
        userInvitations: [],
      };
    case 'IMPORT_EXCEL_OPTION_TYPES_START':
      return { ...state, options: [] };

    case 'IMPORT_EXCEL_OPTION_TYPES_DONE':
      return {
        ...state,
        options: action.options,
      };

    case 'CRITERIA_ERRORS':
      return {
        ...state,
        criteriaErr: action.criteriaErr,
      };

    case 'ACCEPT_INVITATION_DONE':
      return {
        ...state,
        userInvitations: state.userInvitations.filter(
          element => element.projectId !== action.projectId
        ),
      };
    case 'DECLINE_INVITATION_START':
      return state;

    case 'DECLINE_INVITATION_DONE':
      return {
        ...state,
        userInvitations: state.userInvitations.filter(
          element => element.projectId !== action.projectId
        ),
      };
    default:
      return state;
  }
}
